<template>
    <transition name="modal" v-if="isActive">
        <div class="modal-mask">
            <div class="modal-form modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            {{ $PPlusEngine.getDictionary($route.params.lang, 'เข้าสู่ระบบ', 'Sign In') }}
                            <button @click="hide()"><font-awesome-icon :icon="['fas', 'times']" /></button>
                        </h4>
                    </div>        
                    <div class="modal-body">
                        <div class="form-group">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'อีเมล', 'Email') }}</label>
                            <input type="email" class="form-control" placeholder="email@website.com" maxlength="100" :class="$PPlusEngine.highlightInvalidField(loginValidate.email.invalid)" v-model="loginForm.email" />
                            <span class="error-message" v-if="loginValidate.email.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกอีเมล', 'Please input email') }}</span>
                            <span class="error-message" v-if="loginValidate.email.format">{{ $PPlusEngine.getDictionary($route.params.lang, 'รูปแบบอีเมลไม่ถูกต้อง', 'Email format is invalid') }}</span>
                        </div>
                        <div class="form-group">
                            <label>{{ $PPlusEngine.getDictionary($route.params.lang, 'รหัสผ่าน', 'Password') }}</label>
                            <input type="password" class="form-control" placeholder="password" maxlength="50" :class="$PPlusEngine.highlightInvalidField(loginValidate.password.invalid)" v-model="loginForm.password" @keyup.enter="submitLogin()" />
                            <span class="error-message" v-if="loginValidate.password.blank">{{ $PPlusEngine.getDictionary($route.params.lang, 'ยังไม่ได้กรอกรหัสผ่าน', 'Please input your password') }}</span>
                        </div>
                        <span class="error-message" v-if="loginValidate.form.invalid">{{ loginValidate.form.message }}</span>
                        <AcceptPDPA @updateAcceptance="updateAcceptance($event)"></AcceptPDPA>
                        <div class="action">
                            <button class="btn btn-main btn-block" :class="{ 'blocked': !loginForm.isAccept }" @click="submitLogin()">{{ $PPlusEngine.getDictionary($route.params.lang, 'เข้าสู่ระบบ', 'Sign In') }}</button>
                        </div>
                        <section class="group-link">
                            <div class="wrapper">
                                <button class="link" @click="showRegister()">{{ $PPlusEngine.getDictionary($route.params.lang, 'ลงทะเบียน', 'Sign Up') }}</button>
                            </div>
                            <div class="wrapper">
                                <span class="link">|</span>
                            </div>
                            <div class="wrapper">
                                <button class="link" @click="showForgetPassword()">{{ $PPlusEngine.getDictionary($route.params.lang, 'ลืมรหัสผ่าน', 'Forget Password') }}</button>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import PPlusModal from '@/resources/PPlusModal.js';
import PPlusNotify from '@/resources/PPlusNotify';
import AcceptPDPA from '@/components/AcceptPDPA';

export default {
    mixins: [PPlusNotify],
    components: { AcceptPDPA },
    props: {
        fields: Object
    },
    data() {
        return {
            isActive: false,
            loginForm: this.initModelLogin(),
            loginValidate: this.initValidateLogin()
        }
    },
    watch: {
        isActive(curr) {
            if (curr) {
                this.$WeHelper.modalScrollable(true);
            }
            else {
                this.$WeHelper.modalScrollable(false);
            }
        }
    },
    methods: {
        show() {
            this.isActive = true;
        },
        hide() {
            this.isActive = false;
        },
        initModelLogin() {
            return { email: '', password: '', langCode: this.$route.params.lang, isAccept: false };
        },
        initValidateLogin() {
            return { 
                email: { invalid: false, blank: false, format: false }, 
                password: { invalid: false, blank: false },
                form: { invalid: false, message: '' }
            }
        },
        showRegister() {
            let page = this;
            page.hide();

            setTimeout(function(){
                page.$PPlusModal.register();
            }, 0);
        },
        showForgetPassword() {
            let page = this;
            page.hide();
            
            setTimeout(function(){
                page.$PPlusModal.forgetPassword();
            }, 0);
        },
        updateAcceptance(value) {
            this.loginForm.isAccept = value;
        },
        submitLogin() {
            if (this.loginForm.isAccept) {
                this.loginValidate = this.initValidateLogin();

                if (!this.validateField()) {
                    let loader = this.$WeHelper.modalLoad();
                    let apiURL = this.$PPlusConfig.ApiURL;

                    this.$WeHelper.postAPI(apiURL, '/api/user/general-login', this.loginForm).then((response) => {
                        if (!this.$WeHelper.isNullOrEmpty(response.data)) {
                            if (response.data.isAuthen) {
                                this.$cookie.set('token', response.data.token, { expires: 7 });
                                location.reload();
                            }
                            else {
                                loader.hide();
                                this.loginValidate.form.invalid = true;
                                this.loginValidate.form.message = response.data.message;
                            }
                        }
                        else {
                            loader.hide();
                            this.alertSystemError();
                        }
                    });
                }
            }
        },
        validateField() {
            var isError = false;

            if (!this.loginForm.email) {
                this.loginValidate.email.invalid = true;
                this.loginValidate.email.blank = true;
                isError = true;
            }
            if (!this.$WeHelper.validateEmail(this.loginForm.email)) {
                this.loginValidate.email.invalid = true;
                this.loginValidate.email.format = true;
                isError = true;
            }
            if (!this.loginForm.password) {
                this.loginValidate.password.invalid = true;
                this.loginValidate.password.blank = true;
                isError = true;
            }

            return isError;
        }
    },
    beforeMount() {
        PPlusModal.EventBus.$on('showLogin', () => {
            this.show();
        });
    }
}
</script>